import {Message} from "element-ui";

export default {
    methods: {
        compare(a, b) {
            const disA = a.distance;
            const disB = b.distance;

            let comparison = 0;
            if (disA > disB) {
                comparison = 1;
            } else if (disA < disB) {
                comparison = -1;
            }
            return comparison;
        },
        referNameSearch(queryString, cb) {
            var recommendArray = []
            var candidate = this.accessName
            for (var i = 0; i < candidate.length; i++) {
                var dis = this.$calculateLevDistance(queryString.toLowerCase(), candidate[i]['value'].toLowerCase())
                if (candidate[i]['value'].toLowerCase().includes(queryString.toLowerCase())) {
                    dis = dis - 100;
                }
                recommendArray.push({"value": candidate[i]['value'], "distance": dis})
            }
            recommendArray.sort(this.compare)
            var results = recommendArray.slice(0, 5)
            cb(results);
        },
        sendReferToOther(){
            if(this.referToOtherName != '' && this.referToOtherEmail != ''){
                this.referToOtherEmailList.push({"name":this.referToOtherName,"email":this.referToOtherEmail})
                this.referToOtherName = ''
                this.referToOtherEmail = ''
            }
            // currently only internal
            let invitationData = {
                senderId: this.uid,
                // reviewerId: this.referToOtherEmail,
                reviewerList: this.referToOtherEmailList,
                applicantId: this.currentApplicant,
                applicantName: this.personalData.english_last_name+', '+this.personalData.english_first_name,
                // reviewerName: this.referToOtherName,
                referType: this.referToType
            }
            if(this.referToOtherEmailList.length == 0){
                Message({
                    message: "Please input Name and Email",
                    type: "error"
                })
                return
            }
            console.log("invitationData")
            console.log(invitationData)
            this.$request.sendReviewInvitation(invitationData).then(res => {
                console.log(res.data);
                this.referToOtherEmailList = []
                Message({
                    message: "Invitation sent",
                    type: "success"
                })
            }, 'success').catch((err) => {
                console.log(err)
                Message({
                    message: "Error",
                    type: "error"
                })
            });
        },
    },
}
